import api from '../../helpers/axios'

export const state = {

};

export const getters = {

};

export const mutations = {

};

export const actions = {
    uploadFile(_,  data) {
        return new Promise((resolve) => {
            api.post("/upload", data).then((res) => {
                resolve(res.data.data)
            })
        });
    },
};